import React, { useEffect, useState } from "react";
import Dashchit from "../Pages/Chits/dashChit";
import TicketList from "../Pages/TicketList/ticketList";
import BarGraph from "../PieAndBarCharts/BarGraph";
import PieChart from "../PieAndBarCharts/PieChart";
import "./EmployeeDashboard.css";
import Cookies from "universal-cookie";
import { Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Logger } from "../../../Logger/Logger";
import CustomToaster from "../../../Ui/toaster/CustomToaster";

const EmployeeDashboard = () => {
  const navigate = useNavigate();
  const cookies = new Cookies();
  const apiKey = cookies.get("UserLogin");
  const [ticketCountData, setTicketCountData] = useState("");
  const [helper, setHelper] = useState(true);
  const [toaster, setToaster] = useState(false);
  const [title, setTitle] = useState("");
  const [subTitle, setSubTitle] = useState("");
  const [variant, setVariant] = useState("");
  const BASE_URL = process.env.REACT_APP_BASE_URL_NEW;

  useEffect(() => {
    if (
      (cookies && cookies.get("UserDetails") == undefined) ||
      cookies.get("adminRole") == undefined ||
      cookies.get("sysAdminRole") == undefined
    ) {
      setToaster(true);
      setTitle("Success");
      setVariant("success");
      setSubTitle(`Log-in successful`);
      setTimeout(() => {
        setToaster(false);
      }, 2000);
    }
  }, []);
  useEffect(() => {
    axios
      .get(`${BASE_URL}/dashboard/ticket_count/`, {
        headers: { Authorization: `Bearer ${apiKey}` },
      })
      .then((res) => {
        setTicketCountData(res.data.data);

        Logger.debug("ticketCount", res);
      })
      .catch((error) => {
        Logger.error("error in ticketCount", error);

        if (error.response.status == 403) {
          cookies.remove("UserLogin");
          cookies.remove("UserDetails");
          cookies.remove("adminRole");
          cookies.remove("sysAdminRole");
          cookies.remove("createdBy");
          cookies.remove("UserLoginAccessToken");
          cookies.remove("UserName");
          navigate("/");
        }
        if (error.response.status == 404) {
          navigate("/*");
          setTimeout(() => {
            navigate("/secured/empDashboard");
          }, 5000);
        }
      });

    axios
      .get(`${BASE_URL}/user/login/`, {
        headers: { Authorization: `Bearer ${apiKey}` },
      })
      .then((res) => {
        Logger.debug("res at useLoginreq", res);
        cookies.set("UserDetails", res.data.data.name);
        cookies.set("adminRole", res.data.data.is_admin);
        cookies.set("sysAdminRole", res.data.data.is_system_admin);
      })
      .catch((error) => {
        Logger.error("error in user login", error);
        if (error.response.status == 403) {
          cookies.remove("UserLogin");
          cookies.remove("UserDetails");
          cookies.remove("adminRole");
          cookies.remove("sysAdminRole");
          cookies.remove("createdBy");
          cookies.remove("UserLoginAccessToken");
          cookies.remove("UserName");
          navigate("/");
        }
        if (error.response.status == 404) {
          navigate("/*");
          setTimeout(() => {
            navigate("/secured/empDashboard");
          }, 5000);
        }
      });
  }, []);

  const userRole = cookies.get("sysAdminRole");

  Logger.debug("userRole", userRole);

  document.title = "Dashboard | ITSupport-Helpdesk";
  return (
    <>
      <div className="homecontainer">
        <Typography
          component="h1"
          variant="h5"
          className="!text-[22px] flex flex-row justify-start"
        >
          Dashboard
        </Typography>
        <div className="flex flex-col mt-[10px]">
          <div className="dashdetails">
            {userRole === true ? (
              <div className="dashindicators">
                <Dashchit
                  name={"two"}
                  text={"High"}
                  data={ticketCountData.High}
                ></Dashchit>
                <Dashchit
                  name={"one"}
                  text={"Open"}
                  data={ticketCountData.Unassigned}
                ></Dashchit>
                <Dashchit
                  name={"three"}
                  text={"In Progress"}
                  data={ticketCountData.InProgress}
                ></Dashchit>
                <Dashchit
                  name={"four"}
                  text={"Closed"}
                  data={ticketCountData.Closed}
                ></Dashchit>
              </div>
            ) : (
              <div className="dashindicators_users">
                <Dashchit
                  name={"two"}
                  text={"High"}
                  data={ticketCountData.High}
                ></Dashchit>
                <Dashchit
                  name={"one"}
                  text={"Open"}
                  data={ticketCountData.Unassigned}
                ></Dashchit>
                <Dashchit
                  name={"three"}
                  text={"In Progress"}
                  data={ticketCountData.InProgress}
                ></Dashchit>
                <Dashchit
                  name={"four"}
                  text={"Closed"}
                  data={ticketCountData.Closed}
                ></Dashchit>
              </div>
            )}
            <div className="main_contents justify-between gap-[2%] w-[100%]">
              <div className="charts">
                <PieChart />
                <BarGraph asd={helper} />
              </div>
              <div className="dashlistdiv">
                <TicketList></TicketList>
              </div>
            </div>
          </div>
        </div>
      </div>
      {toaster ? (
        <CustomToaster
          title={title}
          subTitle={subTitle}
          variant={variant}
        ></CustomToaster>
      ) : (
        <></>
      )}
    </>
  );
};

export default EmployeeDashboard;
